import { useMutation } from "@tanstack/react-query";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";

export const useSendPasswordResetEmail = (onSuccess: () => void) => {
    return useMutation({
        mutationKey: ['sendPasswordResetEmail'],
        mutationFn: async (email: string) => {
            return sendPasswordResetEmail(auth, email)
        },
        onSuccess
    });
};